import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const softwareBacklogConfigProviderEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "ai-rovo-actions-software-backlog-config-provider" */ './SoftwareBacklogConfigProvider'
		).then((module) => module.SoftwareBacklogConfigProviderEntry),
	),
	getPreloadProps: () => ({}),
});
